import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, unref as _unref } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "row justify-content-center mb-3"
}
const _hoisted_2 = { class: "col-12 text-center" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = {
  key: 1,
  class: "row justify-content-center"
}
const _hoisted_5 = ["data-index"]
const _hoisted_6 = ["onClick"]
const _hoisted_7 = ["src"]
const _hoisted_8 = { class: "threeLineEllipsis" }
const _hoisted_9 = { key: 2 }

import { useTenantConfig } from "@/composables/useTenantConfig";
import { FlowItem } from "@/models/Configuration/FlowItem";
import { TreeItem } from "@/models/Configuration/TreeItem";
import { ServiceModel } from "@/models/Step/ServiceModel";
import constants from "@/models/Utils/constants";
import _ from "lodash";
import { computed, onMounted, ref, watch, inject } from "vue";
import { useI18n } from "vue-i18n";
import { useRoute, useRouter } from "vue-router";
import { useStore } from "../../models/Store/store";


export default /*#__PURE__*/_defineComponent({
  __name: 'BookWorkflow',
  setup(__props) {

const router = useRouter();
const route = useRoute();
const store = useStore();
const tenantConfig = useTenantConfig();
const { t } = useI18n();
const emitter = inject("emitter");

const selectedItem = ref(null);
const bookingFlow = ref<TreeItem<FlowItem>[]>([]);
const buttonStepsToShow = ref<TreeItem<FlowItem>>(null);
const showTitle = ref(false);
const hasMunicipalityChoiceActive = ref(false);

const initBookingFlow = () => {
  if (
    _.isNull(store.tenantConfig) === false &&
    _.isUndefined(store.tenantConfig) === false &&
    _.isNull(store.tenantConfig.bookingFlow) === false &&
    _.isUndefined(store.tenantConfig.bookingFlow) === false
  ) {
    bookingFlow.value = store.tenantConfig.bookingFlow;
    buttonStepsToShow.value = bookingFlow.value[0];
    showTitle.value = true;
  } else {
    bookingFlow.value = [];
    buttonStepsToShow.value = null;
    showTitle.value = false;
  }
};

const goToNextStep = () => {
  var node = selectedItem.value;
  if (node != null) {
    // Set current selection
    const service = new ServiceModel();
    service.id = node.item.service.id;
    service.name = node.item.service.name;
    service.privacyPolicyId = node.item.service.privacyPolicyId;
    store.stepsMade.service = service;

    const locationRouteSelection = tenantConfig.getRouteNameLocationSelection();

    if (node.item.isService && node.item.service.typeId == 2) {
      router.push({ name: "recalluserdata" });
    } else {
      hasMunicipalityChoiceActive.value =
        tenantConfig.hasMunicipalityChoiceActive.value;

      if (hasMunicipalityChoiceActive.value) {
        if (store.stepsMade && store.stepsMade.municipality) {
          router.push({ name: locationRouteSelection });
        } else {
          router.push({ name: "municipality" });
        }
      } else {
        router.push({ name: locationRouteSelection });
      }
    }
  }
};

watch(
  () => route.params.id,
  () => {
    if (bookingFlow.value.length === 0) {
      initBookingFlow();
    }
    if (route.params && route.params.id) {
      if (bookingFlow.value.length > 0) {
        var selectedNode = tenantConfig.findNodeByIdFromNodeArray(
          bookingFlow.value,
          parseInt(route.params.id as string)
        );
        if (!selectedNode.item.isService) {
          selectedItem.value = null;
          buttonStepsToShow.value = selectedNode;
        } else {
          selectedItem.value = selectedNode;
        }
      }
    }
    //caso url del tipo bookingflow
    else {
      if (bookingFlow.value.length > 0) {
        selectedItem.value = null;
        buttonStepsToShow.value = bookingFlow.value[0];
      }
    }
  },
  { immediate: true }
);

watch(
  () => selectedItem.value,
  (newVal) => {
    if (newVal) {
      emitter.emit(constants.CAN_GO_NEXT_STEP, true);
    } else {
      emitter.emit(constants.CAN_GO_NEXT_STEP, false);
    }
  },
  { immediate: true }
);

const existsFlow = computed(() => {
  return bookingFlow.value.length > 0;
});

onMounted(() => {
  store.stepsMade.service = null;
  store.stepsMade.location = null;

  emitter.on(constants.GO_NEXT_STEP, () => {
    console.log("received goNextStep BookWorkflow");
    goToNextStep();
  });
});

const goAheadNavigation = (node: TreeItem<FlowItem>) => {
  if (node !== null && node !== undefined) {
    if (!node.item.isService) {
      selectedItem.value = null;
      router.push({
        name: "bookflowchoice",
        params: { id: node.item.id.toString() },
      });
    } else {
      selectedItem.value = node;
    }
  }
};

const getImageSrc = (node: TreeItem<FlowItem>) => {
  return tenantConfig.getImageSourceOfNode(node);
};

const bookEditHasSameService = (node: TreeItem<FlowItem>) => {
  if (
    _.isNull(store.bookedit) === false &&
    node.isLeaf &&
    node.item.isService &&
    node.item.service.id
  ) {
    if (
      store.bookedit.slots[0].service.id.toString() ===
      node.item.service.id.toString()
    ) {
      return true;
    }
  }
  return false;
};

const isItemSelected = (node: TreeItem<FlowItem>) => {
  if (_.isNull(selectedItem.value) === false) {
    if (selectedItem.value.item.id === node.item.id) {
      return true;
    }
  }
  return false;
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("span", null, [
    (showTitle.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            (buttonStepsToShow.value && buttonStepsToShow.value.item.title)
              ? (_openBlock(), _createElementBlock("h2", _hoisted_3, _toDisplayString(buttonStepsToShow.value.item.title), 1))
              : _createCommentVNode("", true)
          ])
        ]))
      : _createCommentVNode("", true),
    (existsFlow.value && buttonStepsToShow.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(buttonStepsToShow.value.children, (item, index) => {
            return (_openBlock(), _createElementBlock("div", {
              key: item.item.id,
              class: "col-12 col-md-6 col-xxl-4 d-grid gap-2",
              "data-index": index
            }, [
              _createElementVNode("button", {
                type: "button",
                class: _normalizeClass(["btn btn-lg my-3", [
            isItemSelected(item) ? 'btn-primary' : 'btn-outline-primary',
          ]]),
                onClick: ($event: any) => (goAheadNavigation(item))
              }, [
                _createElementVNode("div", null, [
                  (getImageSrc(item) !== '')
                    ? (_openBlock(), _createElementBlock("img", {
                        key: 0,
                        src: getImageSrc(item),
                        style: {"max-height":"40px"}
                      }, null, 8, _hoisted_7))
                    : _createCommentVNode("", true),
                  _createElementVNode("span", _hoisted_8, _toDisplayString(item.item.isService && item.isLeaf
                  ? item.item.service.name
                  : item.item.name), 1)
                ])
              ], 10, _hoisted_6)
            ], 8, _hoisted_5))
          }), 128))
        ]))
      : _createCommentVNode("", true),
    (!existsFlow.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
          _createElementVNode("h5", null, _toDisplayString(_unref(t)("messages.noAvailability")), 1)
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})